export default __webpack_public_path__ + "static/media/talk-up.fff61aa8.png";